import { render, staticRenderFns } from "./VisualizationUserAccessBi.vue?vue&type=template&id=b735d3f6&lang=pug"
import script from "./VisualizationUserAccessBi.vue?vue&type=script&lang=js"
export * from "./VisualizationUserAccessBi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b735d3f6')) {
      api.createRecord('b735d3f6', component.options)
    } else {
      api.reload('b735d3f6', component.options)
    }
    module.hot.accept("./VisualizationUserAccessBi.vue?vue&type=template&id=b735d3f6&lang=pug", function () {
      api.rerender('b735d3f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/powerbi/VisualizationUserAccessBi.vue"
export default component.exports